import actionType from "../constents/action.type"

export const setToken = (token)=>{
    return {
        type:actionType.SET_TOKEN,
        payload:{
            token:token
        }
    }
}

export const setUserData = (data)=>{
    return {
        type:actionType.SET_USER_DATA,
        payload:{
            data:data
        }
    }
}

export const checkPermission = (permissions, key)=>{

    if(permissions.find(permission=>permission=="user_super_admin")){
        return true;
    }
    return (permissions.length==0)?false:((permissions.find(permission=>permission==key))?true:false);
}